/* Dogs Supreme – Experiments Framework v2.0 (2026-05-11)
 * Lightweight A/B-Bucket-Allocation via localStorage, universal fuer PDP-Conviction-Pilot.
 *
 * Aktive Experimente:
 *   pdp_conviction_2026_05 – Bestseller-Badge + Reassurance + Quote
 *     Produkte: air-mesh-pro, comfort-pro
 *     Group A = Control (Komponenten versteckt)
 *     Group B = Variant (Komponenten sichtbar mit Pop-In)
 */
(function() {
  'use strict';

  // Liste der Produkt-Handles im Pilot
  var PILOT_HANDLES = ['air-mesh-pro', 'comfort-pro'];

  function getExperimentGroup(expId) {
    var key = 'ds_exp_' + expId;
    try {
      var stored = localStorage.getItem(key);
      if (stored === 'A' || stored === 'B') return stored;
    } catch (e) { /* SecurityError im Private-Mode → fall through */ }
    var group = Math.random() < 0.5 ? 'A' : 'B';
    try { localStorage.setItem(key, group); } catch (e) { /* silent */ }
    return group;
  }

  function trackAssignment(expId, group, handle) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ds_experiment_assigned',
      experiment_id: expId,
      experiment_group: group,
      product_handle: handle
    });
  }

  // Locale-safe Path-Detection: matched /products/<handle> mit optionalem /xx Prefix
  function detectPilotHandle() {
    for (var i = 0; i < PILOT_HANDLES.length; i++) {
      var handle = PILOT_HANDLES[i];
      var re = new RegExp('^(?:\\/[a-z]{2})?\\/products\\/' + handle + '(?:\\/|\\?|$)');
      if (re.test(window.location.pathname)) return handle;
    }
    return null;
  }

  var activeHandle = detectPilotHandle();
  if (activeHandle) {
    var expId = 'pdp_conviction_2026_05';
    var group = getExperimentGroup(expId);
    document.body.setAttribute('data-exp-pdp-conviction', group);
    trackAssignment(expId, group, activeHandle);
  }

  // Position-Fix v4.0: Wizard zwischen Size-Buttons und Reassurance einfuegen.
  // Reihenfolge: Color-Swatches → Size-Buttons → Wizard → Reassurance
  function moveDsConvictionElements() {
    var wizard = document.querySelector('.sw-wrapper');
    var reassurance = document.querySelector('.ds-reassurance');
    var wizardBlock = wizard ? (wizard.closest('.product-block') || wizard) : null;

    if (wizardBlock && reassurance) {
      // Wizard direkt VOR Reassurance einsetzen
      if (reassurance.parentNode && reassurance.previousSibling !== wizardBlock) {
        reassurance.parentNode.insertBefore(wizardBlock, reassurance);
      }
    } else if (wizardBlock) {
      // Fallback: Wizard nach variant_picker (alte Logik wenn Reassurance nicht da)
      var variantInput = document.querySelector('[data-variant-input]');
      if (variantInput) {
        var pickerBlock = variantInput.closest('.product-block');
        if (pickerBlock && pickerBlock.parentNode && pickerBlock.nextSibling !== wizardBlock) {
          pickerBlock.parentNode.insertBefore(wizardBlock, pickerBlock.nextSibling);
        }
      }
    }
  }

  // Bold-Highlighting v14: NUR erster Satz (vor erstem <br>) komplett bold.
  // Restlicher Text bleibt normal. XSS-safe: kein innerHTML, nur replaceChild + textContent.
  function highlightReassuranceKeywords() {
    var container = document.querySelector('.ds-reassurance__text');
    if (!container) return;
    // Erster Kind-Knoten ist normalerweise der erste TEXT_NODE (erster Satz),
    // gefolgt von <br><br><text>...
    var firstChild = container.firstChild;
    if (!firstChild || firstChild.nodeType !== 3 /* TEXT_NODE */) return;
    var text = firstChild.nodeValue;
    if (!text || !text.trim()) return;
    // Wenn bereits in <strong> gewrappt (z.B. bei Re-Run), abbrechen
    if (firstChild.parentNode.firstElementChild &&
        firstChild.parentNode.firstElementChild.tagName === 'STRONG') return;
    var strong = document.createElement('strong');
    strong.textContent = text;
    container.replaceChild(strong, firstChild);
  }

  function runPositioning() {
    moveDsConvictionElements();
    highlightReassuranceKeywords();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    runPositioning();
  } else {
    document.addEventListener('DOMContentLoaded', runPositioning);
  }
})();
